<template>
    <div>
        <h1>
            hello user {{$route.params.id}}
        </h1>
    </div>
</template>

<script>
    export default {
        name: "user"
    }
</script>

<style scoped>

</style>